export default {
    data: () => ({
        unloadMessage: 'Do you really want to exit this page?',
        cancelTokenSource: null,
    }),

    computed: {
        /**
         * Indicates whether unload should be prevented or not.
         *
         * @returns {boolean} Prevent unload or not?
         */
        isPreventingUnload() {
            return this.$store.state?.UIState?.preventUnload || false;
        },
    },

    methods: {
        /**
         * Changes "preventUnload" state value.
         *
         * @param  {boolean} state Prevent unload or not?
         */
        preventUnload(state) {
            this.$store.commit('changeUIState', { preventUnload: state });
        },

        /**
         * Fires after cancelling request.
         */
        cancelCleanup() {
            this.cancelTokenSource = null;
        },
    },

    /**
     * Handles "before route leave" action.
     *
     * @param  {object}    to    To route
     * @param  {object}    from  From route
     * @param  {Function}  next  Request function
     */
    beforeRouteLeave(to, from, next) {
        if (this.isPreventingUnload && ! confirm(this.unloadMessage)) {
            next(false);
        } else {
            /**
             * Aborts current request if cancel token is set.
             */
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel();

                this.cancelCleanup();
            }

            next();
        }
    },
};
